import { ClientError } from "./client-error";
export class CruxClientError extends ClientError {}
